export default __webpack_public_path__ + "static/rovo-button-light-0d74fd66f9d176005aaa1a9c6bce58d0d8f5c7335d3474b73a28a143516284ff.png";